module.exports = __webpack_public_path__ + "0934a5d9712ffa4b642c15d32f74d56c.png";